<mat-card class="center">
  <h1>Login Required</h1>
  <mat-card-content>
    <nf-login (login)="login($event)"
      [error]="error | async"
      [loading]="loading | async">
    </nf-login>

    <div class="password-reset">
      <a routerLink="/reset">Forgot your password?</a>
    </div>
  </mat-card-content>
</mat-card>